import React from "react";
import {Route, Routes} from "react-router";
import CardGame from "../../game/card/CardGame";

export default function GameRouter() {
    return (
        <Routes>
            <Route index path="card" element={<CardGame/>} />
        </Routes>
)
}
